/**
 * Currency Configuration
 * Centralized configuration for country flags and currency symbols
 */

export const CURRENCY_CONFIG = {
    germany: {
        flag: "http://purecatamphetamine.github.io/country-flag-icons/3x2/DE.svg",
        symbol: "€",
    },
    france: {
        flag: "http://purecatamphetamine.github.io/country-flag-icons/3x2/FR.svg",
        symbol: "€",
    },
    "united arab emirates": {
        flag: "http://purecatamphetamine.github.io/country-flag-icons/3x2/AE.svg",
        symbol: "AED",
    },
    egypt: {
        flag: "http://purecatamphetamine.github.io/country-flag-icons/3x2/EG.svg",
        symbol: "EGP",
    },
};

export const DEFAULT_CURRENCY = {
    flag: "http://purecatamphetamine.github.io/country-flag-icons/3x2/EU.svg",
    symbol: "€",
};

export const PRODUCT_CONFIG = {
    MAX_TAGS: 7,
    TAG_SLICE_START: 0,
    TAG_SLICE_END: 5,
    IMAGE_SIZE: 250,
};
